import Card from "components/card/Card";
import Spin from "components/spin/spin";
import React from "react";
import { useTranslation } from "react-i18next";
import { ITeeTimeNew } from "redux/reducers/models/teetime";
import { useDashboardContext } from "../../DashboardContext";
import { IDashboardEvent } from "./dashboardEventTimeline";
import PlayerBookingGraph from "./PlayerBookingGraph";
import "./playerVolume.scss";

interface IProps {
  teetimes: Array<ITeeTimeNew>;
  events?: Array<IDashboardEvent>;
}

export default function PlayerVolume(props: IProps) {
  const { teetimes, events } = props;
  const { t } = useTranslation();
  const { selectedCourseIds } = useDashboardContext();

  return (
    <Card className="ui-player-volume" title={t("Player Volume")}>
      <Card.Section>
        {!teetimes ? (
          <div style={{ height: "40px", display: "flex", width: "40px", margin: "auto" }}>
            <Spin />
          </div>
        ) : (
          <PlayerBookingGraph teetimes={teetimes} courseIds={selectedCourseIds} events={events} />
        )}
      </Card.Section>
    </Card>
  );
}
